const routes = {
  main: '/',
  mainTariffs: '/#tariffs',
  mainFaq: '/#faq',
  account: '/account', // Account
  yearResults: 'year-results',
  privacy: '/privacy', // Privacy policy
  agreement: '/agreement', // User Agreement
  personalPolicy: '/personal_policy', // Personal Data Processing policy
  thanksForPayment: '/thank', // Thanks for Payment
  tickets: '/tickets',
  tickets_baku: '/tickets_baku',
  ufc308vote: '/ufc308vote',
  ufc308voteThankyou: '/ufc308vote/thankyou',
};

export default routes;
